interface EmailPreviewProps {
  subject: string;
  content: string;
  companyName?: string;
  companyLogo?: string;
}

// Sample placeholders for preview
const sampleData = {
  '{nome}': 'João Silva',
  '{customer_name}': 'João Silva',
  '{valor}': 'R$ 1.250,00',
  '{vencimento}': '15/02/2026',
  '{billing_due_date}': '15/02/2026',
  '{link_pagamento}': 'https://pay.digisend.com.br/abc123',
  '{billing_url}': 'https://pay.digisend.com.br/abc123',
  '{company_name}': 'Digisend',
  '{company_phone}': '(11) 99999-9999',
};

function replacePlaceholders(text: string): string {
  let result = text;
  Object.entries(sampleData).forEach(([key, value]) => {
    result = result.replace(new RegExp(key.replace(/[{}]/g, '\\$&'), 'g'), value);
  });
  return result;
}

// Convert HTML content ensuring proper paragraph spacing
function processHtmlContent(html: string): string {
  if (!html) return '';
  
  let processed = replacePlaceholders(html);
  
  // Garantir que os parágrafos tenham espaçamento adequado
  // Adicionar margin-bottom aos <p> que não têm estilo inline
  processed = processed.replace(/<p(?![^>]*style)([^>]*)>/g, '<p$1 style="margin-bottom: 16px;">');
  
  return processed;
}

export function EmailPreview({ subject, content, companyName = 'Digisend', companyLogo }: EmailPreviewProps) {
  const previewSubject = replacePlaceholders(subject);
  const previewContent = processHtmlContent(content);

  return (
    <div className="bg-muted/30 rounded-xl border overflow-hidden max-w-md mx-auto">
      {/* Email client header */}
      <div className="bg-background border-b p-3">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center">
            {companyLogo ? (
              <img src={companyLogo} alt="" className="w-8 h-8 rounded-full object-cover" />
            ) : (
              <span className="text-primary font-bold text-sm">
                {companyName.charAt(0).toUpperCase()}
              </span>
            )}
          </div>
          <div className="flex-1 min-w-0">
            <p className="font-medium text-sm text-foreground truncate">{companyName}</p>
            <p className="text-xs text-muted-foreground truncate">noreply@{companyName.toLowerCase()}.com.br</p>
          </div>
        </div>
      </div>

      {/* Subject */}
      <div className="bg-background border-b px-4 py-2">
        <p className="font-semibold text-foreground">
          {previewSubject || 'Assunto do e-mail...'}
        </p>
      </div>

      {/* Email body */}
      <div className="bg-white p-6">
        {/* Logo */}
        <div className="flex justify-center mb-6">
          {companyLogo ? (
            <img src={companyLogo} alt="" className="h-12 object-contain" />
          ) : (
            <div className="text-2xl font-bold text-primary">{companyName}</div>
          )}
        </div>

        {/* Content */}
        <div 
          className="prose prose-sm max-w-none text-[#333]"
          dangerouslySetInnerHTML={{ 
            __html: previewContent || '<p style="color: #999;">Digite o conteúdo do e-mail para ver a pré-visualização...</p>' 
          }}
        />

        {/* Footer */}
        <div className="mt-8 pt-4 border-t text-center">
          <p className="text-xs text-muted-foreground">
            Este e-mail foi enviado por {companyName}.<br />
            © {new Date().getFullYear()} {companyName}. Todos os direitos reservados.
          </p>
        </div>
      </div>
    </div>
  );
}
